import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Logout = () => {
  const navigate = useNavigate();

  useEffect(() => { 
    // Clear session
    localStorage.removeItem("user");
    // Redirect to login 
    navigate("/login", { replace: true });
  }, [navigate]);

  return null; // Nothing to render
};

export default Logout;
